import { ErrorBoundary } from 'react-error-boundary'
import * as Sentry from '@sentry/react'
import PropTypes from 'prop-types'
import ErrorFallback from './ErrorFallback'

const ContainerErrorBoundary = ({ children, containerName = 'this section' }) => {
  const handleError = (error, info) => {
    Sentry.captureException(error, {
      extra: {
        containerName,
        componentStack: info.componentStack,
      },
    })
  }

  return (
    <ErrorBoundary
      onError={handleError}
      fallbackRender={({ resetErrorBoundary }) => (
        <ErrorFallback resetErrorBoundary={resetErrorBoundary} containerName={containerName} />
      )}
    >
      {children}
    </ErrorBoundary>
  )
}

ContainerErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  containerName: PropTypes.string,
}

export default ContainerErrorBoundary
